export default [
  'Respiratory disorders',
  'Cardiac Disease',
  'Tonsil/adenoid problems',
  'Rheumatic Fever',
  'Sinusitis',
  'Hepatic Disease',
  'Renal Disease',
  'Nutritional disorders',
  'Anemia',
  'Endocrine disturbances',
  'Diabetes',
  'Cleftlip / palate infections',
  'Bleeding disorder',
  'Arthritis',
  'Hepatitis',
  'Seizures/Convulsions',
  'HIV/AIDS',
  'Speech problems',
  'Tuberculosis',
  'Behavioral problems',
]
